/** Shared names for the Chrome popup OAuth skip beacon. No logger / navigator. */

export const POPUP_CALLBACK_SKIP_EVENT = 'turnkey.popup_callback.skip_provider';
export const POPUP_CALLBACK_SKIP_COUNTER = 'frontend.turnkey_popup_callback_skip';
